// extracted by mini-css-extract-plugin
export var cardContainer = "_mo-0";
export var cardHeader = "_mo-2";
export var collapsedState = "_mo-3";
export var dragHandle = "_mo-5";
export var dragHandleIcon = "_mo-6";
export var dragging = "_mo-1";
export var titleArea = "_mo-4";